import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createBaggage,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  addedBaggageTemplate,
  baggageToPay,
  defaultBoardingPassResult,
  defaultCheckInBaggagePolicies,
  journeys,
  noItemToPayError,
  paymentRecords,
  paymentRecordsCheckoutMock,
  seatmap,
} from '../../mock/data';
import {
  authorization,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

/**
 * OW 1Journey
 * 1ADT
 * Add/remove baggages
 */
export const ow1Journey1AdtChargeableBaggagesRetrieve: MockMap = {
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 1
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 2
    })
  ])
  ],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(baggageToPay),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError])
  ],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};

export const ow1Journey1AdtChargeableBaggagesCheckoutPayment: MockMap = {
  ...ow1Journey1AdtChargeableBaggagesRetrieve,
  confirmJourneyPaymentRecord: [createMockData(paymentRecordsCheckoutMock)],
  createJourneyPaymentRecord: [createMockData(paymentRecordsCheckoutMock)]
};
